import { TaggedFail } from './Fail'
import { parseArgs } from './parseArgs'
import { TDetailsNone, TFailArgs } from './types'

export class UnknownFail extends TaggedFail('Unknown') {
  static fromC(...args: TFailArgs<TDetailsNone, 'cause'>) {
    return (cause: unknown): UnknownFail => {
      const opts = parseArgs(args)
      opts.cause = cause
      return new UnknownFail(opts)
    }
  }

  static from(
    cause: unknown,
    ...args: TFailArgs<TDetailsNone, 'cause'>
  ): UnknownFail {
    return UnknownFail.fromC(...args)(cause)
  }
}
